module.exports = __webpack_public_path__ + "img/1197922560.df77f4a1.jpg";